/**
 * ChatHeader — header desktop do Chat Hub (estilo ChatGPT)
 * Mostra nome do app, modelo selecionado, botão perfil e nova conversa
 * Usa tokens do design system
 */
import { T } from '../../styles/tokens';
import { Signal } from '@preact/signals';
import { tenantName } from '../TenantLogo';

interface LLMModel {
  id: string;
  name: string;
  provider: string;
}

interface ChatHeaderProps {
  /** Signal com lista de modelos */
  models: Signal<LLMModel[]>;
  /** Signal com modelo selecionado */
  selectedModel: Signal<string>;
  /** Se deve mostrar botão de nova conversa */
  showNewChat: boolean;
  /** Callback para navegar ao perfil */
  onProfile: () => void;
  /** Callback para nova conversa */
  onNewChat: () => void;
}

export function ChatHeader({ models, selectedModel, showNewChat, onProfile, onNewChat }: ChatHeaderProps) {
  const selModel = models.value.find(m => m.id === selectedModel.value);

  return (
    <div style={{
      padding: '0 16px', height: 48, borderBottom: `1px solid ${T.border}`,
      background: T.bg, display: 'flex', alignItems: 'center', flexShrink: 0,
      position: 'relative',
    }}>
      {/* Esquerda: Nome do tenant + modelo selecionado */}
      <div>
        <span style={{ fontSize: 18, fontWeight: 700, color: T.text, padding: '6px 12px' }}>
          {tenantName()}
          {selModel ? <span style={{ color: T.textSecondary, fontWeight: 400, fontSize: 14 }}> · {selModel.name}</span> : null}
        </span>
      </div>

      {/* Espaçador flex */}
      <div style={{ flex: 1 }} />

      {/* Direita: perfil + nova conversa */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        {/* Ícone perfil */}
        <button onClick={onProfile} style={{
          width: 32, height: 32, borderRadius: '50%', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: 'transparent', border: 'none', color: T.text, flexShrink: 0,
        }}
          onMouseEnter={(e: any) => { e.currentTarget.style.background = T.border; }}
          onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
        </button>

        {/* Nova conversa */}
        {showNewChat && (
          <button onClick={onNewChat}
            style={{
              width: 32, height: 32, borderRadius: '50%', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              background: 'transparent', border: '1.5px solid rgba(255,255,255,0.2)',
              color: T.text, flexShrink: 0,
            }}
            onMouseEnter={(e: any) => { e.currentTarget.style.background = T.border; }}
            onMouseLeave={(e: any) => { e.currentTarget.style.background = 'transparent'; }}
            title="Nova conversa">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}
